import React, { useContext, useEffect, useState, useRef, useCallback, useMemo } from 'react';
import { getRequest, postRequest, putRequest, deleteRequest, tabulatorGet } from '../../../api/ApiController';
import { DatabaseContext } from '../../../redux/DatabaseStore';
import { ReactTabulator, reactFormatter } from 'react-tabulator';
import '../../../assets/css/style.css';
import '../../../assets/css/iconsmenu.css';
import { confirmDialog } from 'primereact/confirmdialog';
import { Dialog } from 'primereact/dialog';
import { MdSearch } from "react-icons/md";
import { MdSearchOff } from "react-icons/md";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import { AddIcon, EditIcon, CopyIcon, DeleteIcon, StepBackIcon, PrintIcon, SearchIcon, ExportIcon, RefreshIcon, VerticalLineIcon, BackToFirstIcon, BackIcon, ForwardIcon, ForwardToLastIcon, FavoriteIcon, PriceIcon, EditRowIcon } from "../../svg/svgIcons";
import { useReactToPrint } from "react-to-print";
import { DateTime } from "luxon";
import { PanelMenu } from 'primereact/panelmenu';
import { Checkbox } from 'primereact/checkbox';
import UtilContext from "../../../components/UtilContext";
import IntersectionObserverWrapper from '../../../components/toolbar/IntersectionObserverWrap';
import { OverflowMenuProvider } from '../../../components/toolbar/OverflowMenu';
import { scrollToFirst as scrollToFirstUtil, scrollUp as scrollUpUtil, scrollDown as scrollDownUtil, scrollToLast as scrollToLastUtil } from '../../../utils/tabulatorScroll';
import { getModuleSettingValue } from '../../../utils/moduleSettings';
import { resetTabulatorMask } from '../../../utils/tabulatorResetMask';
import { extractSafePaginationParams, createDedupedAjaxRequest, cleanSorters, refreshProgressiveFromStart } from '../../../utils/tabulatorProgressiveLoading';
import { getPusherChannel } from '../../../utils/pusherChannel';
import { primeMultiSelectHeaderFilter } from '../../../utils/primeMultiSelectHeaderFilter';
import { LocaleContext } from '../../../components/LocaleContext';
import { defaultProductLogoSrc } from '../../../constants/brandingDisplay';
import { buildCanonicalPrintFooterHtml, buildCanonicalPrintHeaderHtml } from '../../../utils/printChrome';
import { applyTabulatorRuntimeI18n } from '../../../utils/tabulatorRuntimeI18n';
const TRAINING_COMPANY_CERT_RECORD_LIST_COLUMN_I18N_KEYS = Object.freeze({
  'name': 'TrainingCompanyCertRecordList.Text.Nazov_sk_firmy',
  'defined_id': 'Common.DefinedId',
  'types': 'Common.Type',
  'tel_number': 'Common.Column.Phone',
  'contact_person': 'Common.ContactPerson',
  'description': 'Common.Description',
  'company_status_display': 'TrainingCompanyCertRecordList.Text.Stav_sk_firmy',
  'specific_id': 'TrainingCompanyCertRecordList.Text.Nazov_sk_firmy',
  'address': 'BusinessPartnerList.Column.Address',
  'fax': 'BusinessPartnerList.Column.Fax',
  'email': 'Common.Email',
  'web_address': 'BusinessPartnerList.Column.WebAddress',
});


const DEFAULT_COLUMNS_VISIBLE_CERT_RECORD = { name: true, defined_id: true, types: true, address: true, tel_number: true, fax: true, email: true, web_address: true, contact_person: true, description: true, company_status_display: true };

export default function TrainingCompanyCertRecordList({ preview = null }) {
const { t, locale } = useContext(LocaleContext);

    const [state, dispatch] = useContext(DatabaseContext);
    const module_settings = state.module_settings || [];
    const showExcludedCompaniesByCompany = getModuleSettingValue(module_settings, 'training', 'show_excluded_training_companies_list_by_company', '0');
    const showDeactivatedCertsByCompany = getModuleSettingValue(module_settings, 'training', 'show_deactivated_certs_list_by_company', '0');
    const { setDialogText, setVisible, openFavoriteDialog, toast, setFastView, setUserMaskFilter , openChosenNotificationPreferences} = useContext(UtilContext);
    const resetMask = () => resetTabulatorMask({ page: 'TrainingCompanyCertRecordList', defaultColumnsVisible: DEFAULT_COLUMNS_VISIBLE_CERT_RECORD, ref, columns, setColumnsVisible });

    const [stepBackIcon, setStepBackIcon] = useState(true);
    const [insertIcon,setInsertIcon] = useState(true);
    const [editIcon,setEditIcon] = useState(true);
    const [deleteIcon,setDeleteIcon] = useState(true);
    const [favoriteIcon,setFavoriteIcon] = useState(false);
    const [copyIcon,setCopyIcon] = useState(true);
    const [searchIconColor,setSearchIconColor] = useState("");

    const [visibleSearch,setVisibleSearch] = useState(false);
    const [visibleLoading,setVisibleLoading] = useState(false);
    const [searchValue,setSearchValue] = useState('');
    const [printVisible,setPrintVisible] = useState(false);
    const [printValue,setPrintValue] = useState("Zoznam");

    const [markUnmark, setMarkUnmarked] = useState(true);

    const [columnsVisible, setColumnsVisible] = useState({ ...DEFAULT_COLUMNS_VISIBLE_CERT_RECORD });
    const [maskVisible, setMaskVisible] = useState(false);
const [editFormGauge, setEditFormGauge] = useState([]);

    const ref = useRef(null);
    const elementRef = useRef(null);
    const componentRef = useRef(null);
    const overlayRef = useRef(null);
    const savedHScrollRef = useRef({ left: 0, pending: false });
    const inFlightRef = useRef({ sig: null, promise: null });
    const completedCacheRef = useRef(new Map());

    const pageSizePc = useMemo(() => {
      const v = (state.module_settings || []).find(s => s.module === 'global' && s.key === 'page_size_pc')?.value;
      const n = parseInt(v, 10);
      return (Number.isFinite(n) && n > 0) ? n : 50;
    }, [state.module_settings]);
    const getTable = useCallback(() => ref.current?.table ?? ref.current, []);
    const captureHScroll = useCallback(() => {
      const table = getTable();
      if (!table) return;
      const holder = table.rowManager?.element;
      if (!holder) return;
      savedHScrollRef.current = { left: holder.scrollLeft, pending: true };
    }, [getTable]);
    const restoreHScroll = useCallback(() => {
      if (!savedHScrollRef.current.pending) return;
      const table = getTable();
      if (!table) return;
      const holder = table.rowManager?.element;
      const header = table.columnManager?.contentsElement;
      if (!holder) return;
      const left = savedHScrollRef.current.left;
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          holder.scrollLeft = left;
          if (header) header.scrollLeft = left;
          savedHScrollRef.current.pending = false;
        });
      });
    }, [getTable]);
    const refreshFromStart = useCallback(() => refreshProgressiveFromStart(getTable, completedCacheRef, t('Common.LoadingEllipsis')), [getTable]);

  useEffect(() => {
    const table = typeof getTable === 'function' ? getTable() : null;
    if (!table?.getColumns) return;
    applyTabulatorRuntimeI18n(table, t, {
      columnTitleKeys: TRAINING_COMPANY_CERT_RECORD_LIST_COLUMN_I18N_KEYS,
      placeholder: typeof t === 'function' ? t('Common.NoData') : undefined,
      reformatRows: true,
    });
  }, [locale, t, getTable]);

    const listType = 'training';
    useEffect(() => {
      const channel = getPusherChannel();
      if (!channel) return;
      const DEDUPE_MS = 800;
      const lastHandled = { key: '', at: 0 };
      const shouldSkip = (eventType, id) => {
        if (id == null) return true;
        const key = `${eventType}-${id}`;
        const now = Date.now();
        if (lastHandled.key === key && now - lastHandled.at < DEDUPE_MS) return true;
        lastHandled.key = key;
        lastHandled.at = now;
        return false;
      };
      const onCreated = (data) => {
        const id = data?.id ?? null;
        if (id == null || shouldSkip('company.created', id)) return;
        getRequest(`/api/companies/${id}?type=${listType}&show_excluded_companies=${showExcludedCompaniesByCompany}`).then((res) => {
          const rowData = res?.data?.data ?? res?.data ?? res;
          if (!rowData?.id) return;
          const table = getTable();
          const row = table?.getRow?.(rowData.id);
          if (row) row.update(rowData);
          else table?.addData?.([rowData], true);
        }).catch(() => {
          const table = getTable();
          const row = table?.getRow?.(id) ?? table?.getRows?.().find((r) => r.getData().id === id);
          if (row) row.delete();
        });
      };
      const onUpdated = (data) => {
        const id = data?.id ?? null;
        if (id == null || shouldSkip('company.updated', id)) return;
        getRequest(`/api/companies/${id}?type=${listType}&show_excluded_companies=${showExcludedCompaniesByCompany}`).then((res) => {
          const rowData = res?.data?.data ?? res?.data ?? res;
          if (!rowData?.id) return;
          const table = getTable();
          const row = table?.getRow?.(rowData.id) ?? table?.getRows?.().find((r) => r.getData().id === id);
          if (row) row.update(rowData);
          else table?.addData?.([rowData], true);
        }).catch(() => {
          const table = getTable();
          const row = table?.getRow?.(id) ?? table?.getRows?.().find((r) => r.getData().id === id);
          if (row) row.delete();
        });
      };
      const onDeleted = (data) => {
        const id = data?.id ?? null;
        if (id == null || shouldSkip('company.deleted', id)) return;
        const table = getTable();
        const row = table?.getRow?.(id) ?? table?.getRows?.().find((r) => r.getData().id === id);
        if (row) row.delete();
      };
      channel.bind('company.created', onCreated);
      channel.bind('company.updated', onUpdated);
      channel.bind('company.deleted', onDeleted);
      return () => {
        channel.unbind('company.created', onCreated);
        channel.unbind('company.updated', onUpdated);
        channel.unbind('company.deleted', onDeleted);
      };
    }, [getTable, listType, showExcludedCompaniesByCompany]);

    const buildRequestParams = useCallback((paramsFromTabulator = {}) => {
      const extra = {
        type: 'training',
        show_excluded_companies: showExcludedCompaniesByCompany,
        show_deactivated_certs: showDeactivatedCertsByCompany,
        ...extractSafePaginationParams(paramsFromTabulator),
      };
      if (extra.size === undefined || extra.size === null) extra.size = pageSizePc;
      const table = getTable();
      const hf = table?.getHeaderFilters?.() ?? [];
      hf.forEach(f => {
        if (f?.field !== undefined && f?.field !== null && f.value !== undefined && f.value !== null && String(f.value).trim() !== '') {
          extra['filter_' + f.field] = String(f.value).trim();
        }
      });
      const sorters = cleanSorters(paramsFromTabulator?.sorters ?? table?.getSorters?.() ?? []);
      if (sorters?.length) extra.sorters = JSON.stringify(sorters);
      if (searchValue && String(searchValue).trim() !== '') extra.search = String(searchValue).trim();
      return extra;
    }, [pageSizePc, getTable, searchValue, showExcludedCompaniesByCompany, showDeactivatedCertsByCompany]);

    const baseAjaxRequest = useMemo(
      () => createDedupedAjaxRequest(buildRequestParams, tabulatorGet, inFlightRef, completedCacheRef),
      [buildRequestParams]
    );
    const ajaxRequestFunc = useCallback((url, config, params) => {
      return baseAjaxRequest(url, config, params).then(res => ({
        ...res,
        data: (res.data || []).map(row => ({
          ...row,
          company_certificates: row.certificates || row.company_certificates || [],
        })),
      }));
    }, [baseAjaxRequest]);

function searchTable(){
        setSearchIconColor("active");
        if (searchValue === " " || (searchValue && String(searchValue).trim() === '')) {
          getTable()?.clearFilter?.();
          refreshFromStart();
        } else {
          captureHScroll();
          refreshFromStart();
        }
        setVisibleSearch(false);
      }
    
    
      const rowClick = (e, row) => {
        console.log(e, row);
     };
    
      const onSelectRow = (data, rows) => {
        setEditFormGauge(data);
          if(data.length === 0){
            setInsertIcon(true);
            setEditIcon(true);
            setCopyIcon(true);
            setDeleteIcon(true);
          }
          else{
            setInsertIcon(false);
            setEditIcon(false);
            setCopyIcon(false);
            setDeleteIcon(false);
          }
      };

      function onEditRow(training_company){
        console.log(training_company);
        dispatch({type: 'create_new_tab', name: t('Util.Tab.TrainingCompanyCertValidity'), translationKey: 'Util.Tab.TrainingCompanyCertValidity', legacyLabel: t('Util.Tab.TrainingCompanyCertValidity'),page:'TrainingCompanyCertRecordDetail',props:{training_company: training_company,type:'edit'},mask:'trng025'})
      };
      
      function EditRowFormatter(props) {
        const rowData = props.cell.getRow().getData();
        return <div className='flex items-center justify-center w-full h-full'><button type='button' onClick={() => onEditRow(rowData)}><EditRowIcon/></button></div>;
      }

      function CompanyStatusFormatter(props) {
        const rowData = props.cell.getRow().getData();
        const v = rowData?.validity;
        return <span>{v == 1 || v === '1' ? 'Aktívny' : 'Vyradený'}</span>;
      }

      function typesHeaderFilter(headerValue, rowValue, rowData) {
        if (!headerValue || headerValue === '') return true;
        let types = rowData.types || [];
        types = types.map(item => item === 'customer' ? t('BusinessPartnerAdd.Type.Customer') : item);
        types = types.map(item => item === 'supplier' ? t('BusinessPartnerAdd.Type.Supplier') : item);
        types = types.map(item => item === 'calibration_company' ? t('BusinessPartnerAdd.Type.CalibrationCompany') : item);
        types = types.map(item => item === 'training_company' ? t('BusinessPartnerAdd.Type.TrainingCompany') : item);
        return types.join(' ').toLowerCase().includes(headerValue.toLowerCase());
      }

      function TypeFormatter(props) {
        const rowData = props.cell.getRow().getData();
        let types = rowData.types || [];
        types = types.map(item => item === 'customer' ? t('BusinessPartnerAdd.Type.Customer') : item);
        types = types.map(item => item === 'supplier' ? t('BusinessPartnerAdd.Type.Supplier') : item);
        types = types.map(item => item === 'calibration_company' ? t('BusinessPartnerAdd.Type.CalibrationCompany') : item);
        types = types.map(item => item === 'training_company' ? t('BusinessPartnerAdd.Type.TrainingCompany') : item);
        return <span>{types.join(', ') || '—'}</span>;
      }

      const scrollToFirst = () => scrollToFirstUtil(getTable());
      const scrollUp = () => scrollUpUtil(getTable());
      const scrollDown = () => scrollDownUtil(getTable());
      const scrollToLast = () => scrollToLastUtil(getTable());

      const [draggingItem, setDraggingItem] = useState(null); 
      const [columns, setColumns] = useState([
        { title: '', field: 'specific_id', formatter: "rowSelection", titleFormatter: "rowSelection", hozAlign: "center", width: 44, minWidth: 44, headerSort: false, resizable: false },
        { title: '', field: 'editor', hozAlign: "center", width: 44, minWidth: 44, headerSort: false, formatter: reactFormatter(<EditRowFormatter />), resizable: false },
        { title: t('TrainingCompanyCertRecordList.Text.Nazov_sk_firmy'), field: 'name', headerFilter: "input", minWidth: 260 },
        { title: t('Common.DefinedId'), field: 'defined_id', headerFilter: "input", width: 200 },
        { title: t('Common.Type'), field: 'types', headerFilter: "input", formatter: reactFormatter(<TypeFormatter />), minWidth: 200, headerFilterFunc: typesHeaderFilter },
        { title: t('BusinessPartnerList.Column.Address'), field: 'address', headerFilter: "input", width: 200 },
        { title: t('Common.Column.Phone'), field: 'tel_number', editor: "input", headerFilter: "input", width: 200 },
        { title: t('BusinessPartnerList.Column.Fax'), field: 'fax', editor: "input", headerFilter: "input", width: 200 },
        { title: t('Common.Email'), field: 'email', editor: "input", headerFilter: "input", width: 200 },
        { title: t('BusinessPartnerList.Column.WebAddress'), field: 'web_address', editor: "input", headerFilter: "input", width: 200 },
        { title: t('Common.ContactPerson'), field: 'contact_person', editor: "input", headerFilter: "input", width: 200 },
        { title: t('Common.Description'), field: 'description', editor: "input", headerFilter: "input", width: 200 },
        { title: t('TrainingCompanyCertRecordList.Text.Stav_sk_firmy'), field: 'company_status_display', headerFilter: primeMultiSelectHeaderFilter, headerFilterParams: { options: [{ label: 'Aktívny', value: 'Aktívny' }, { label: 'Vyradený', value: 'Vyradený' }], placeholder: t('TrainingCompanyCertRecordList.Text.Stav_sk_firmy') }, headerFilterFunc: (headerValue, rowValue, rowData) => { if (!headerValue || String(headerValue).trim() === '') return true; const selectedRaw = Array.isArray(headerValue) ? headerValue : (typeof headerValue === 'object' && Array.isArray(headerValue?.value) ? headerValue.value : String(headerValue).split(/[\s,;|]+/)); const selected = selectedRaw.map(s => String(s).trim()).filter(Boolean); if (selected.length === 0) return true; const v = rowData?.validity; const label = (v == 1 || v === '1') ? 'Aktívny' : 'Vyradený'; return selected.includes(label); }, minWidth: 260, formatter: reactFormatter(<CompanyStatusFormatter />) },
      ]);

      function editTrainingCompanyCertificate(){
        const selected = getTable()?.getSelectedData?.() ?? [];
        if (selected.length) dispatch({ type: 'create_new_tab', name: t('Util.Tab.TrainingCompanyCertValidity'), translationKey: 'Util.Tab.TrainingCompanyCertValidity', legacyLabel: t('Util.Tab.TrainingCompanyCertValidity'), page: 'TrainingCompanyCertRecordDetail', props: { training_company: selected[0], type: 'edit' }, mask: 'trng025' });
      }
    
    function setMask(item,value){
      const columnVisible = {...columnsVisible};
     columnVisible[item] = value;
     console.log(columnVisible);
      for (const val in columnVisible) {
        if (columnVisible[val] === false) getTable()?.hideColumn?.(`${val}`);
        else getTable()?.showColumn?.(`${val}`);
      }
      setColumnsVisible(columnVisible);
      setTimeout(() => { getTable()?.redraw?.(true); }, 0);
    }
  
    const itemRenderer = (item, options) => (
      <a className="flex align-items-center px-3 py-2 cursor-pointer items-center bg-[#333] text-white w-[180px]" onClick={options.onClick}>
          <span className={`${item.icon} text-primary`} />
          <span className={`mx-2 ${item.items && 'font-semibold'}`}>{item.label}</span>
          {item.shortcut && <span className="ml-auto border-1 surface-border border-round surface-100 text-xs p-1">{item.shortcut}</span>}
      </a>
    );
  
    const [expandedKeys, setExpandedKeys] = useState({});
  
    const handleClickOutside = (event) => {
      if (overlayRef.current && !overlayRef.current.contains(event.target)) {
          setExpandedKeys({});
      }
    };
  
    useEffect(() => {
        document.addEventListener('click', handleClickOutside, true);
        return () => {
            document.removeEventListener('click', handleClickOutside, true);
        };
    }, []);

    const items = [
      {
        key: '0',
        label: t('Common.Actions'),
        icon: 'pi pi-sliders-v',
        template: itemRenderer,
        items: [
              {
                key: '0_1',
                label: t('Common.SetFilter'),
                icon: 'pi pi-filter',
                command: () => { setUserMaskFilter("TrainingCompanyCertRecordList", "set_filters", null, getTable()?.getHeaderFilters?.() ?? [], null); OverflowMenuProvider.setVisible(null); setExpandedKeys({}); refreshFromStart(); },
                template: itemRenderer,
            },
              {
                key: '0_2',
                label: t('Common.ClearFilter'),
                icon: 'pi pi-filter-slash',
                command: () => { setUserMaskFilter("TrainingCompanyCertRecordList", "set_filters", null, [], null); getTable()?.clearHeaderFilter?.(); OverflowMenuProvider.setVisible(null); setExpandedKeys({}); refreshFromStart(); },
                template: itemRenderer,
            },
            {
                key: '0_3',
                label: t('Common.SetSorting'),
                icon: 'pi pi-sort-alt',
                command: () => { setUserMaskFilter("TrainingCompanyCertRecordList", "set_sorters", null, null, null, getTable()?.getSorters?.() ?? []); OverflowMenuProvider.setVisible(null); setExpandedKeys({}); refreshFromStart(); },
                template: itemRenderer,
            },
            {
                key: '0_4',
                label: t('Common.ClearSorting'),
                icon: 'pi pi-sort-alt-slash',
                command: () => { setUserMaskFilter("TrainingCompanyCertRecordList", "set_sorters", null, null, null, []); getTable()?.setSort?.([]); OverflowMenuProvider.setVisible(null); setExpandedKeys({}); refreshFromStart(); },
                template: itemRenderer,
            },
            {
                key: '0_5',
                label: t('Common.SetMask'),
                icon: 'pi pi-server',
                command: () => {setMaskVisible(true);OverflowMenuProvider.setVisible(null);setExpandedKeys({});},
                template: itemRenderer,
            },
            {
                key: '0_5b',
                label: t('Common.ResetUserMask'),
                icon: 'pi pi-refresh',
                command: () => { resetMask(); OverflowMenuProvider.setVisible(null); setExpandedKeys({}); },
                template: itemRenderer,
            },
            {
              key: '0_6',
              label: t('Common.Notifications'),
              icon: 'pi pi-envelope',
              command: () => {openChosenNotificationPreferences('TrainingCompanyCertRecordList');OverflowMenuProvider.setVisible(null);},
              template: itemRenderer,
          },
        ]
      }
    ];function changeMarkings(value){
      const columnVisible = {...columnsVisible};
        for (let val in columnVisible) {
          if (columnVisible[val] !== "id" && columnVisible[val] !== "editor") {
            columnVisible[val] = value;
            getTable()?.hideColumn?.(`${val}`);
          }
        }
        setColumnsVisible(columnVisible);
        setTimeout(() => { getTable()?.redraw?.(true); }, 0);
    }

    function previewFilter(data, filterParams){
      const certs = data.company_certificates || data.certificates || [];
      if (filterParams.time_period === "after") {
        return (certs.length === 0) || (certs.length > 0 && new Date(certs[0].end_of_validity) < new Date());
      }
      if (filterParams.time_period === "15") {
        return certs.length > 0 && new Date(certs[0].end_of_validity) <= new Date(new Date().setDate(new Date().getDate() + 15)) && new Date(certs[0].end_of_validity) > new Date();
      }
      if (filterParams.time_period === "30") {
        return certs.length > 0 && new Date(certs[0].end_of_validity) <= new Date(new Date().setDate(new Date().getDate() + 30)) && new Date(certs[0].end_of_validity) > new Date();
      }
      if (filterParams.time_period === "others") {
        return certs.length > 0 && new Date(certs[0].end_of_validity) > new Date(new Date().setDate(new Date().getDate() + 30));
      }
      return false;
    }

    
    return(
        <>
        <div className='w-full h-10 flex flex-row bg-[#333]'>
        <IntersectionObserverWrapper>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="edit"><button className="disabled:opacity-25" disabled={editIcon} onClick={() => editTrainingCompanyCertificate()}><EditIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="print"><button onClick={() => getTable()?.print?.(false, true)}><PrintIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="search"><button onClick={searchIconColor !== "active" ? () => setVisibleSearch(true) : () => { setSearchIconColor(""); setSearchValue(""); getTable()?.clearFilter?.(); refreshFromStart(); }}>{searchIconColor === "" ? <MdSearch fill='#fff' strokeWidth="0" className='w-[28px] h-[28px]' aria-hidden="true" title={t('Common.Search')}/> : <MdSearchOff fill='#fff' strokeWidth="0" className='w-[28px] h-[28px]' aria-hidden="true" title={t('Common.CancelSearch')}/>}</button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="export"><button onClick={() => getTable()?.download?.("xlsx", "data.xlsx", { sheetName: "MyData" })}><ExportIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="refresh"><button type="button" onClick={() => { captureHScroll(); refreshFromStart(); }} title={t('Common.Refresh')}><RefreshIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="vert"><VerticalLineIcon/></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="first"><button onClick={() => scrollToFirst()}><BackToFirstIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="back"><button onClick={() => scrollUp()}><BackIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="forward"><button onClick={() => scrollDown()}><ForwardIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="last"><button onClick={() => scrollToLast()}><ForwardToLastIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="vert"><VerticalLineIcon/></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="favorite"><button className="disabled:opacity-25" disabled={favoriteIcon} onClick={() => openFavoriteDialog(t('Common.ByCompany'),"TrainingCompanyCertRecordList")}><FavoriteIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="fast"><button onClick={() => setFastView("TrainingCompanyCertRecordList",columnsVisible,columns)}><PriceIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="vert"><VerticalLineIcon/></div>
        <div className="card flex justify-content-center z-[100]" data-targetid="actions" ref={overlayRef}>
            <PanelMenu model={items} expandedKeys={expandedKeys} onExpandedKeysChange={setExpandedKeys} className="w-full md:w-20rem"/>
          </div>
          </IntersectionObserverWrapper>
      </div>
      <div className='px-1 bg-white rounded-md shadow-md'>
<div className="flex flex-col overflow-x-auto no-scrollbar min-h-[calc(100vh-177px)]">
<div className="overflow-hidden">
  <div className="inline-block w-full py-2" >
    
    <div ref={elementRef}>
      <ReactTabulator
      key={`training-company-cert-record-${showExcludedCompaniesByCompany}-${showDeactivatedCertsByCompany}`}
      data={undefined}
      className='h-[calc(100vh_-_193px)]'
      onRef={(r) => (ref.current = r?.current)}
      columns={columns}
      events={{
        rowClick: rowClick,
        rowSelectionChanged: onSelectRow,
        tableBuilt: () => {
          const table = getTable();
          if (table && preview != null) table.setFilter(previewFilter, { time_period: preview });
          let mask = state.user_mask_filters?.filter(m => m.page === "TrainingCompanyCertRecordList") ?? [];
          const safeParse = (v, fallback) => {
            if (v === null || v === undefined) return fallback;
            if (typeof v === "string") { try { return JSON.parse(v); } catch { return fallback; } }
            return v;
          };
          if (mask.length > 0 && table) {
            const attributes = safeParse(mask[0].attributes, []);
            const filters = safeParse(mask[0].filters, []);
            const sorters = safeParse(mask[0].sorters, []);
            const json_columns = safeParse(mask[0].columns, {});
            if (Array.isArray(attributes) && attributes.length > 1) table.setColumnLayout(attributes);
            if (Array.isArray(filters)) filters.forEach(f => table.setHeaderFilterValue(f.field, f.value));
            if (Array.isArray(sorters) && sorters.length > 0) table.setSort(sorters);
            if (json_columns && typeof json_columns === "object") {
              setColumnsVisible(json_columns);
              for (const column in json_columns) {
                if (json_columns[column] === false) table.hideColumn(column);
                else table.showColumn(column);
              }
            }
          }
        },
        headerFilterChanged: () => { captureHScroll(); refreshFromStart(); },
        renderComplete: () => restoreHScroll(),
        columnMoved: () => setUserMaskFilter("TrainingCompanyCertRecordList", "column_move", null, null, getTable()?.getColumnLayout?.()),
        columnResized: () => setUserMaskFilter("TrainingCompanyCertRecordList", "column_resized", null, null, getTable()?.getColumnLayout?.()),
      }}
      options={{
        layout: "fitColumns",
        renderHorizontal: "virtual",
        movableColumns: true,
        rowHeight: 30,
        printAsHtml: true,
        printHeader: () => buildCanonicalPrintHeaderHtml({
          branding: state?.branding,
          productFallbackSrc: defaultProductLogoSrc,
          companySettingsPrint: state?.company_settings_print,
          moduleSettings: state?.module_settings,
          title: t('Print.Title.TrainingCompanyCertRecordList'),
          printDateLabel: t('Print.DateLabel'),
        }),
        printFooter: () => buildCanonicalPrintFooterHtml({ companySettingsPrint: state?.company_settings_print }),
        printRowRange: "active",
        autoResize: true,
        ajaxURL: '/api/companies/paged',
        progressiveLoad: 'scroll',
        progressiveLoadScrollMargin: 80,
        paginationSize: pageSizePc,
        pagination: false,
        ajaxRequestFunc,
      }}/>
    </div> 
  </div> 
</div> 
</div>
          <Dialog header={t('Common.SearchInList')} visible={visibleSearch} style={{ width: '40vw' }} onHide={() => setVisibleSearch(false)}>
            <div className="flex flex-columns">
              
              <input
                  value={searchValue} onChange={e => setSearchValue(e.target.value)}
                  type="text"
                  className="block w-full px-4 py-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
              />
              <button onClick={() => searchTable()} className='w-16 ml-8 px-4 py-2 tracking-wide text-white transition-colors duration-200 transform bg-zinc-900 rounded-md hover:bg-zinc-700 focus:outline-none focus:bg-zinc-600'><SearchIcon/></button>
            </div>
          </Dialog>
          <Dialog header={t('Common.SetMask')} visible={maskVisible} style={{ width: '70vw' }} onHide={() => setMaskVisible(false)}>
        <div className="flex flex-col">
        <button type="button" onClick={() => {changeMarkings(!markUnmark);setMarkUnmarked(!markUnmark);}} className='m-1 px-4 py-2 text-center tracking-wide text-white transition-colors duration-200 transform bg-zinc-700 rounded-md hover:bg-zinc-500'>{markUnmark ? t('Common.DeselectAllUpper') : t('Common.SelectAllUpper')}</button>
        {columns.map(function(item, index){ 
          if(index<2) return null;
                    return <div 
                        key={index} 
                        className="flex flex-row border border-black rounded-md p-2 m-1"
                    > 
                         <Checkbox onChange={(e) => setMask(item.field,e.checked)} checked={columnsVisible[item.field]}></Checkbox><span className="ml-2">{item.title}</span>
                          
                        {/* Use the React icon component */} 
                    </div> 
                })} 
            <button onClick={() => { setUserMaskFilter("TrainingCompanyCertRecordList", "set_columns", columnsVisible, null, null); setMaskVisible(false); }} className='m-1 px-4 py-2 text-center tracking-wide text-white transition-colors duration-200 transform bg-zinc-900 rounded-md hover:bg-zinc-700 focus:outline-none focus:bg-zinc-600'>{t('Ui.R67.SaveUpper')}</button>
        </div>
      </Dialog>
      
      </div> 
        </>
    )
}